import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[toggleColumn]',
})
export class ToggleColumnDirective {
  @Input() public toggleColumn: string;

  constructor(public elementRef: ElementRef) {}

  public hide(): void {
    this.elementRef.nativeElement.style.display = 'none';
  }

  public show(): void {
    this.elementRef.nativeElement.style.display = '';
   // this.elementRef.nativeElement.style.display = 'table-cell';
  }
}
